var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.display,"bottom":"","color":"success","auto-height":"","vertical":""}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('v-btn',{attrs:{"color":"white","flat":"","icon":""},on:{"click":_vm.closeSnack}},[_c('v-icon',{attrs:{"flat":"","icon":""}},[_vm._v("close")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }